import {all} from 'redux-saga/effects';
import {saga as extrasSaga} from './extras';
import {saga as e2eeSaga} from './e2ee';
import {saga as entitiesSaga} from './entities';
import {saga as telemetrySaga} from './telemetry';
import {saga as uiSaga} from './ui';

export default function* rootSaga() {
  yield all([
    telemetrySaga(),  // Use as first saga.
    e2eeSaga(),
    entitiesSaga(),
    extrasSaga(),
    uiSaga(),
  ]);
}
